module.exports = "https://web-assets.ifttt.com/packs/media/docs/add-trigger-to-connection-38c1220a.png";